var scrollPos = $( window ).scrollTop();

function onTop() {

	if ( $( '.c-on-top' ).length ) {

		if( $( window ).scrollTop() == 0 ) {
			$( 'body' ).addClass( '_top' );
		} else if ( $( 'body' ).hasClass( '_top' ) ) {
			$( 'body' ).removeClass( '_top' );
		}
	}
};

function onBottom() {

	if ( $( '.c-on-bottom' ).length ) {

		if( $( window ).scrollTop() + $( window ).height() == $( document ).height() ) {
			$( 'body' ).addClass( '_bottom' );
		} else if ( $( 'body' ).hasClass( '_bottom' ) ) {
			$( 'body' ).removeClass( '_bottom' );
		}
	}
};

function onScroll( even ) {
	var currentPos = window.pageYOffset || document.documentElement.scrollTop;

	if ( scrollPos > currentPos ) {
		$( 'body' ).removeClass( '_scroll_down' );
	} else {
		$( 'body' ).addClass( '_scroll_down' );
	}

	scrollPos = currentPos;
};

function updateCrossover( $this, $element, className, classNameBody ) {

	var positionStatus = $( window ).scrollTop() > $( $this ).offset().top;

	if ( positionStatus && !$element.hasClass( className ) ) {
		$element.addClass( className );
		$( 'body' ).addClass( classNameBody );
	} else if ( !positionStatus && $element.hasClass( className ) ) {
		$element.removeClass( className );
		$( 'body' ).removeClass( classNameBody );
	}
};

function isElementInViewport (el) {

	// Special bonus for those using jQuery
	if (typeof jQuery === "function" && el instanceof jQuery) {
		el = el[0];
	}

	var rect = el.getBoundingClientRect();

	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
		rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
	);
}

if ( !localStorage.getItem( 'free_shipping_amount' ) ) {

	$.getJSON( 'https://ipinfo.io/json?token=0aa3b8ef751def', function( data ) {

	localStorage.setItem( 'user_country', data.country )

	var country = localStorage.getItem( 'user_country' );

	if ( country == 'CH' ) {
		localStorage.setItem( 'free_shipping_amount', 99 );
		$( 'body' ).attr( 'data-country', 'ch' );
	} else if ( country == 'GB' ) {
		localStorage.setItem( 'free_shipping_amount', 99 );
		$( 'body' ).attr( 'data-country', 'gb' );
	} else {
		localStorage.setItem( 'free_shipping_amount', 99 );
	}
	}).done(function() {
		setFreeShippingAmount();
	});
} else {
	setFreeShippingAmount();
}

function setFreeShippingAmount() {

	if ( $( '.c-free-shipping-amount' ).length ) {
		$( '.c-free-shipping-amount' ).text( $( '.c-currency-symbol' ).text() + '99' );
	}
};

if ( $( '.c-price' ).length ) {
	toFranc(); // to update data in $( '.c-free-shipping-amount' ) on pages without Nosto
}



$( window ).on('DOMContentLoaded load resize scroll', function() {

	$( '.c-video-play-in-view' ).each( function( index, el ) {
		var $video = $(this)[0];
		if ( isElementInViewport( $(this) ) && $video.paused ) {
			$video.play();
		} else if ( !isElementInViewport( $(this) ) && !$video.paused ) {
			$video.pause();
		}
	});
});

$( document ).ready(function() {

	onTop();
	onBottom();
	// parameterizeOutgoingLinks(); // update all static links, all not static links will be updated later

	(function() {

		if ( $( '.c-top-countdown' ).length ) {

			const zeroPad = ( num, places ) => String( num ).padStart( places, '0' );

			var countDownDate = new Date( 'September 23, 2021 18:00:00' ).getTime();

			var x = setInterval( function() {

				var now = new Date().getTime(),
					distance = countDownDate - now,
					hours = Math.floor((distance / (1000 * 60 * 60)),
					minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
					seconds = Math.floor((distance % (1000 * 60)) / 1000));

				$( '.c-countdown' ).html( zeroPad( hours, 2 ) + ' Std <span class="b-top-countdown__countdown_dots">:</span> '
				+ zeroPad( minutes, 2 ) + ' Min <span class="b-top-countdown__countdown_dots">:</span> ' + zeroPad( seconds, 2 ) + ' Sek' );

				if ( distance < 0 ) {
					clearInterval( x );
					$( '.c-top-countdown' ).addClass( '_none' );
				} else {
					if ( $( '.c-top-countdown' ).hasClass( '_none' ) ) {
						$( '.c-top-countdown' ).removeClass( '_none' );
					}
				}
			}, 1000);
		}
	})();

	(function() {

		var emptyStarsInserted = false;

		$( document ).on( 'animationstart', function( event ) {

			if ( event.animationName == 'yotpoNodeInserted' && !emptyStarsInserted ) {

				$( 'div.yotpo.bottomLine > div.yotpo-display-wrapper:not( :has( div.star-clickable ) )' ).each( function( index, el ) {
					var $this = $( this ),
						emptyStars = $(
							'<div class="standalone-bottomline">' +
								'<div class="yotpo-bottomline pull-left star-clickable">' +
									'<span class="yotpo-stars">' +
										'<span class="yotpo-icon yotpo-icon-empty-star pull-left"></span>' +
										'<span class="yotpo-icon yotpo-icon-empty-star pull-left"></span>' +
										'<span class="yotpo-icon yotpo-icon-empty-star pull-left"></span>' +
										'<span class="yotpo-icon yotpo-icon-empty-star pull-left"></span>' +
										'<span class="yotpo-icon yotpo-icon-empty-star pull-left"></span>' +
									'</span>' +
									'<div class="yotpo-clr"></div>' +
								'</div>' +
							'</div>' );

					$this.append( emptyStars );
					emptyStarsInserted = true;
				});
			}
		}, false);
	})();


	(function() {

		if ( $( '.c-month' ).length ) {

			$( '.c-month' ).each( function( index, el ) {

				var monthName;

				switch ( new Date().getMonth() ) {
					case 0:
						monthName = 'January';
						break;
					case 1:
						monthName = 'February';
						break;
					case 2:
						monthName = 'March';
						break;
					case 3:
						monthName = 'April';
						break;
					case 4:
						monthName = 'May';
						break;
					case 5:
						monthName = 'June';
						break;
					case 6:
						monthName = 'July';
						break;
					case 7:
						monthName = 'August';
						break;
					case 8:
						monthName = 'September';
						break;
					case 9:
						monthName = 'October';
						break;
					case 10:
						monthName = 'November';
						break;
					case 11:
						monthName = 'December';
						break;
				}

				$( this ).text( monthName );
			});
		}
	})();

	(function() {

		if ( $( '.c-video-fullscreen' ).length ) {

			$( '.c-video-fullscreen' ).on( 'click', function( event ) {

				var $video = $( this ).siblings( '.c-video-fullscreen__video' ),
					video = $video[0];

				$( 'body' ).addClass( '_modal_active' );
				$video.addClass( 'b-section__video-frame-lg_active' )
				video.muted = !video.muted;
			});
		}
	})();

	$( '.c-video-fullscreen__video' ).on( 'click', function( event ) {
		var video = $( this )[0];
		$( 'body' ).removeClass( '_modal_active' );
		$( this ).removeClass( 'b-section__video-frame-lg_active' );
		video.muted = !video.muted;
	});

	(function() {

		if ( $( '.c-click-pseudo' ).length ) {

			$( '.c-click-pseudo' ).each( function( index, el ) {
				$( this ).on( 'click', function( event ) {
					$( $( this ).data( 'c-click-pseudo-element' ) ).click();
				});
			});
		}
	})();

	(function() {

		if ( $( '.c-add-to-cart, .c-add-to-cart-open' ).length ) {

			$( '.c-add-to-cart, .c-add-to-cart-open' ).on( 'click', function(){
				$.ajax({
					type: 'GET',
					url: '/cart.json',
					success: function (res) {
						$( '.c-add-to-cart__number' ).text( res.item_count );
					}
				});
			});
		}
	})();

	(function() {

		if ( $( 'video.lazy-video' ).length ) {

			let lazyLoadVideos = [].slice.call( document.querySelectorAll( 'video.lazy-video' ) );

			if ( 'IntersectionObserver' in window ) {
				let lazyVideoObserver = new IntersectionObserver( function( entries, observer ) {
					entries.forEach( function( video ) {
						if ( video.isIntersecting ) {
							for ( let source in video.target.children ) {
								let videoSource = video.target.children[ source ];
								if ( typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE' ) {
									videoSource.src = videoSource.dataset.src;
								}
							}
							video.target.load();
							video.target.classList.remove( 'lazy-video' );
							lazyVideoObserver.unobserve( video.target );
						}
					});
				});
				lazyLoadVideos.forEach( function( lazyVideo ) {
					lazyVideoObserver.observe( lazyVideo );
				});
			}
		}
	})();

	(function() { // has to be before all slick initializations

		if ( $( '.c-slick-1-0' ).length ) {

			var $this		= $( '.c-slick-1-0' );

			$this.on( 'init', function( event, slick ) {
				$( this ).parent().addClass( $( this ).data( 'c-slick-1-0-class' ) );
			});

			$this.slick({
				arrows: false,
				dots: true,

				speed: 300,
				slidesToShow: 4,
				slidesToScroll: 4,

				prevArrow:'<div class="slick-prev" style="cursor: poiner"></div>', // for iOs (button tag cuts text shadow in after)
				nextArrow: '<div class="slick-next" style="cursor: poiner"></div>', // for iOs (button tag cuts text shadow in after)
				responsive: [
					{
						breakpoint: 640,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
						}
					}
				]
			});
		}
	})();

	(function() { // has to be before all slick initializations

		if ( $( '.c-slick-1-2' ).length ) {

			var $this		= $( '.c-slick-1-2' );

			$( '.c-slick-1-2' ).slick({
				dots: true,

				speed: 300,
				slidesToShow: 2,
				slidesToScroll: 2,

				prevArrow:'<div class="slick-prev" style="cursor: poiner"></div>', // for iOs (button tag cuts text shadow in after)
				nextArrow: '<div class="slick-next" style="cursor: poiner"></div>', // for iOs (button tag cuts text shadow in after)
			});
		}
	})();

	(function() { // has to be before all slick initializations

		if ( $( '.c-slick-2' ).length ) {

			var $this		= $( '.c-slick-2' );

			$( '.c-slick-2' ).slick({
				dots: true,

				speed: 300,

				centerMode: true,
				variableWidth: true
			});
		}
	})();

	(function() {

		if ( $( '.c-slick-3' ).length ) {

			$( '.c-slick-3' ).slick({
				speed: 300,

				arrows: false,
				dots: true,

				dotsClass: 'c-slick-3__nav c-scroll',
			}).on( 'afterChange', function( event, slick, currentSlide ){

				if ( $( this ).hasClass( 'c-boxes-slider-description' ) ) {

					var $this	= $( this ),
						id		= $this.data( 'c-boxes-slider-description-id' ),
						$items	= $( '.c-boxes-slider-description__item' ).data( 'c-boxes-slider-description-id', id );

					$items.addClass( '_none' );
					$items.filter( '[data-c-boxes-slider-description-number=' + ( currentSlide + 1 ) + ']' ).removeClass( '_none' );
				}
			});
		}
	})();

	(function() {

		if ($('.c-slick-banner').length) {

			$('.c-slick-banner').slick({
				arrows: false,
				dots: false,

				speed: 300,

				autoplay: true,
				autoplaySpeed: 3000,

				slidesToShow: 1,
				slidesToScroll: 1
			});
		};
	})();

	(function() {

		if ( $('.c-slick-product').length ) {

			$('.c-slick-product').slick({
				arrows: false,
				dots: false,

				speed: 300,

				slidesToShow: 4,
				slidesToScroll: 4,

				responsive: [{
				breakpoint: 1200,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centerMode: true,
						variableWidth: true,
					}
				}]
			});
		}
	})();

	(function() {

		if ( $( '.c-slick-5' ).length ) {

			$( '.c-slick-5' ).slick({
				autoplay: true,
				autoplaySpeed: 0,
				speed: 2000,

				cssEase: 'linear',

				variableWidth: true,

				infinite: true,

				arrows: false,
			});
		}
	})();

  	(function() {

		if ( $( '.c-slick-product__advantages' ).length ) {

			$( '.c-slick-product__advantages' ).slick({
				autoplay: false,
				centerMode: true,
				variableWidth: true,
				centerPadding: '30px',
				slidesToShow: 3,
				speed: 300,
				slidesToScroll: 1,
				cssEase: 'linear',
				infinite: true,
				arrows: true,
				prevArrow: $('.c-slick-product__advantages-prev'),
				nextArrow: $('.c-slick-product__advantages-next'),
				responsive: [
					{
						breakpoint: 800,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							variableWidth: false,
							centerMode: false,
							adaptiveHeight: true
						}
					},
				]
			});
		}
	})();

	(function() {

		if ( $( '.c-slick-preloader' ).length ) {

			$( '.c-slick-preloader' ).slick({
				autoplaySpeed: 2000,
				speed: 500,

				vertical: true,
				swipe: false,

				arrows: false,
			});

			$( '.c-slick-preloader__bind' ).on( 'click', function( event ) {
				$( '.c-slick-preloader' ).slick( 'slickPlay' );
			});
		}
	})();

	(function() {

		if ( $( '.c-slick-top' ).length ) {

			$( '.c-slick-top' ).slick({
				autoplaySpeed: 5000,
				speed: 500,
				autoplay: true,
				infinite: true,

				slidesToShow: 1,
				slidesToScroll: 1,

				arrows: false,
				dots: false,

				cssEase: 'linear',
				fade: true,
				adaptiveHeight: true,
			});
		}
	})();

	(function() {

		if ( $( '.c-dropdown' ).length ) {

			$( '.c-dropdown' ).each( function( index, element ) {

				let $this = $( this ),
					$bind = $( '.c-dropdown__bind' ).eq( index );

				$this.add( $bind ).on( 'mouseenter', function(e) {
					$this.addClass( 'b-header__nav-dropdown_active' );
				});

				$this.add( $bind ).on( 'mouseleave', function(e) {
					$this.removeClass( 'b-header__nav-dropdown_active' );
				});
			});
		}
	})();

	(function() {

		if ( $( '.c-option-switcher' ).length ) {

			$( '.c-option-switcher' ).each( function( index, el ) {

				var $this		= $( this ),
					valNumber	= $this.data( 'c-option-switcher-val' ) ? $this.data( 'c-option-switcher-val' ) : 0,
					$element	= $( $this.data( 'c-option-switcher-element' ) ? $this.data( 'c-option-switcher-element' ) : $this ),
					className	= $this.data( 'c-option-switcher-class' ) ? $this.data( 'c-option-switcher-class' ) : 0;

				$this.on( 'change', function( event ) {

					if ( this.value == valNumber && $element.hasClass( className ) ) {
						$element.removeClass( className );
					} else if ( !$element.hasClass( className ) ) {
						$element.addClass( className );
					}
				});
			});
		}
	})();

	(function() {

		if ( $( '.c-scroll' ).length ) {

			$( '.c-scroll' ).each( function( index, el ) {

				$( this ).perfectScrollbar({
					maxScrollbarLength: 120,
					minScrollbarLength: 60,
					wheelPropagation: true
				});
			});
		}
	})();

	(function() {

		if ( $( '.c-accordion' ).length ) {

			$( '.c-accordion' ).each( function( index, el ) {

				$( this ).accordionjs({
					activeIndex: false,
					closeAble: true,
					slideSpeed: 500,
				});
			});
		}
	})();

	(function() {

		if ( $( '.c-manipulate-class' ).length ) {

			$( 'body' ).on( 'click', '.c-manipulate-class', function( event ) { // onlick for buildBambuserList

				var $this			= $( this ),
					$element		= $this.data( 'c-manipulate-class-element' ) ? $this.data( 'c-manipulate-class-element' ).split(', ') : $this,
					className		= $this.data( 'c-manipulate-class-class' ) ? $this.data( 'c-manipulate-class-class' ).split(', ') : undefined,
					operationType	= $this.data( 'c-manipulate-class-operation-type' ) ? $this.data( 'c-manipulate-class-operation-type' ).split(', ') : undefined,
					$closest		= $this.data( 'c-manipulate-class-closest' ) ? $this.data( 'c-manipulate-class-closest' ).split(', ') : undefined;

				$element.forEach( function( el, i ) {
					if ( className ? className[ i ] : false ) {
						if ( $closest ? $closest[ i ] : false ) {
							if ( operationType ? operationType[ i ] == 'remove' : false ) {
								$( $element[ i ] ).closest( $closest[ i ] ).removeClass( className[ i ] );
							} else {
								$( $element[ i ] ).closest( $closest[ i ] ).addClass( className[ i ] );
							}
						} else {
							if ( operationType ? operationType[ i ] == 'remove' : false ) {
								$( el ).removeClass( className[ i ] );
							} else {
								$( el ).addClass( className[ i ] );
							}
						}
					}
				});
			});
		}
	})();

	(function() {

		if ( $( '.c-switcher' ).length ) {

			$( '.c-switcher' ).each( function( index, el ) {

				var $this = $( this );

				$this.on( 'click', function( event ) {
					addingDataAttribute( $this );
				});

				function addingDataAttribute( $this ) {

					var elements    = $this.data( 'c-switcher-element' ) ? $this.data( 'c-switcher-element' ).split(', ') : $this,
						className   = $this.data( 'c-switcher-class' ) ? $this.data( 'c-switcher-class' ).split(', ') : undefined;

					if ( elements != $this ) {
						elements.forEach( function( el, i ) {
							if ( className[i]) {
								if ( !el ) { // if empty
									$this.toggleClass( className[i] );
								} else {
									$( el ).toggleClass( className[i] );
								}
							}
						});
					} else {
						if ( className ) {
							$( elements ).toggleClass( className[0] );
						}
					}
				};
			});
		}
	})();

	(function() {

		if ( $( '.с-filter-form' ).length ) {

			$( '.с-filter-form input' ).click( function (){

				$( this ).closest( 'form' ).submit();
			});
		}
	})();

	(function() {

		if ( $( '.c-popup-img' ).length ) {

			$( '.c-popup-img' ).on( 'click', 'img', function( event ) {

				var $this			= $( this );

				setTimeout(function run() {
					$( '.c-popup-img__btn' ).click();
					$( '.c-slick-4' ).slick('refresh');
				}, 300);

			});
		}
	})();

	(function() {

		if ( $( '.c-open-reviews' ).length && $( '#customerReviews' ).length ) {

			$( '.c-open-reviews' ).on( 'click', function( event ) {

				if ( !$( '#customerReviews' ).parent().hasClass( 'acc_active' ) ) {
					$( '#customerReviews' ).click();
				}
			});
		}
	})();

	(function() {

		if ( $( '.c-live-show-registration' ).length ) {

			$( '.c-live-show-registration' ).each( function( index, el ) {

				var $this = $( this );

				$this.libriform({
					data: $this.serialize() + '&g=RZsSa3', // important to add "g" in data
					url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe?a=UpXmWE&g=RZsSa3', // AND in url too
					callBackSuccess: function( $form, data ) {
						$form.trigger( 'reset' );
						$( location ).prop( 'href', 'https://cvbeauty.de/pages/previous-live-shows' );
					},
					callBackError: function( $form, data ) {
						$form.trigger( 'reset' );
						$( '.c-manipulate-class__form-error--5' ).click();
					}
				});
			});
		}
	})();

	(function() {

		if ( window.location.pathname != '/pages/liveshow' && window.location.pathname != '/pages/live-consulting' ) {
			$.ajax({
				type: 'GET',
				url: 'https://liveshopping-api.bambuser.com/v1/shows?state=live',
				beforeSend: function (xhr) {
					xhr.setRequestHeader('Authorization', 'Token BgvMU91yoRFEfAPD2a7jYbUuyu2y1z5SKPNr6bHBiLM');
				},
				success: function( data ) {

					if ( data.results.length ) {

						$( 'body' ).append( '<div class="b-liveshow-preview" style="background-image: url( ' + data.results[0].curtains.pending.backgroundImage + ' );">' +
							'<button class="b-liveshow-preview__close"></button>' +
							'<div class="b-liveshow-preview__content">' +
								'<a href="/pages/liveshow#shows" class="b-liveshow-preview__title">Live Show Läuft Gerade</a>' +
								'<a href="/pages/liveshow#shows" class="-ol-btn -ol-btn_sm _w_full" tabindex="0"><span class="-ol-btn__text">Teilnehmen</span></a>' +
							'</div>' +
						'</div>' );

						$( 'body' ).on( 'click', '.b-liveshow-preview__close', function() {
							$( '.b-liveshow-preview' ).remove();
						});
					}
				},
			});
		}
	})();

	(function() {

		if ( $( '.c-bambuser-list-live' ).length ) {

			buildBambuserList( 'https://liveshopping-api.bambuser.com/v1/shows?state=live', 'Jetzt Live', 'c-bambuser-list-live' );
		}
	})();

	(function() {

		if ( $( '.c-bambuser-list-next' ).length ) {

			buildBambuserList( 'https://liveshopping-api.bambuser.com/v1/shows', 'Nächste Live Shows', 'c-bambuser-list-next', 'next' );
		}
	})();

	(function() {

		if ( $( '.c-bambuser-list-prev' ).length ) {

			buildBambuserList( 'https://liveshopping-api.bambuser.com/v1/shows?state=ended', 'Vergangene Live Shows', 'c-bambuser-list-prev' );
		}
	})();

	function buildBambuserList( url, title, className, type ) {

		$.ajax({
			type: 'GET',
			url: url,
			beforeSend: function (xhr) {
				xhr.setRequestHeader( 'Authorization', 'Token BgvMU91yoRFEfAPD2a7jYbUuyu2y1z5SKPNr6bHBiLM' );
			},
			success: function( data ) {

				var htmlList = '',
					result = '',
					reverse = false,
					reverseClass = '';

				// to make play button clickable
				if ( !window.initBambuserLiveShopping ) {
					window.initBambuserLiveShopping = function( item ) {
						window.initBambuserLiveShopping.queue.push( item )
					};
					window.initBambuserLiveShopping.queue = [];

					var scriptNode = document.createElement('script');
					scriptNode['src'] = 'https://lcx-embed.bambuser.com/celine-victor/embed.js';

					document.body.appendChild(scriptNode);
				}

				if ( type == 'next' ) {
					reverseClass = ' _flex_dir_row_reverse _just_cont_end';
				}

				data.results.forEach( function( item, i, arr ) {

					var nextPopup = '',
						nextPopupModal = '',
						btnPlayId = '',
						linkPlayId = '';

					if ( type != 'next' ) {
						btnPlayId = ' id="' + className + '__btn-play-' + i + '"';
						linkPlayId = ' id="' + className + '__link-play-' + i + '"';
					}

					if ( type == 'next' && ( item.state == 'ended' || item.state == 'upcoming' ) ) {
						return true;
					}

					var dateOptions = {
							weekday: 'long',
							year: undefined,
							month: 'long',
							day: 'numeric',
							hour: 'numeric',
							minute: 'numeric',
						},
						date = new Date( item.scheduledStartAt ).toLocaleString( 'de-DE', dateOptions );

					if ( type == 'next' ) {
						$( 'body' ).prepend( '<p class="c-video__description">' + item.description + '</p>' );

						var formID = $( '.c-video__description' ).find( '.c-video__id' ).text();

						$( '.c-video__description' ).remove();

						nextPopup = ' c-manipulate-class" data-c-manipulate-class-element="body, .c-manipulate-class----modal--0' + ( i * 1 + 2 ) + '" data-c-manipulate-class-class="_modal_active, b-modal_active';
						nextPopupModal = '<div class="b-modal c-manipulate-class----modal--0' + ( i * 1 + 2 ) + '">' +
							'<div class="b-modal__inner">' +
								'<div class="b-modal__overlay c-manipulate-class" data-c-manipulate-class-element="body, .c-manipulate-class----modal--0' + ( i * 1 + 2 ) + '" data-c-manipulate-class-class="_modal_active, b-modal_active" data-c-manipulate-class-operation-type="remove, remove"></div>' +
								'<div class="b-box b-box_without_outside_space b-box_with_image _block_center b-modal__box">' +
									'<div class="b-box__img-aside" style="background-image: url( ' + item.curtains.pending.backgroundImage + ' );"></div>' +
									'<div class="b-box__close b-modal__close c-form__btn-done c-manipulate-class" data-c-manipulate-class-element="body, .c-manipulate-class----modal--0' + ( i * 1 + 2 ) + '" data-c-manipulate-class-class="_modal_active, b-modal_active" data-c-manipulate-class-operation-type="remove, remove"></div>' +
									'<div class="b-box__body">' +
										'<div class="b-heading-4 b-heading-4_without_decoration _m_b_20 _m_b_15_tb _m_horiz_5_neg_tb_xs">' +
											'<div class="_flex _m_b_30 _m_b_20_tb">' +
												'<div class="b-heading-4__title b-heading-4__title_lg">' +
													'<h4 class="b-heading-4__title-text">' + item.title + '</h4>' +
												'</div>' +
											'</div>' +
											'<p class="b-text-lg b-text-lg_last _c_black">Registriere dich hier für die kostenlose Live Show am</p>' +
										'</div>' +
										'<div class="_m_b_25 _m_b_20_tb">' +
											'<p class="b-note">' + date + '</p>' +
										'</div>' +
										'<form class="c-video__form">' +
											'<div class="-ol-row-input -ol-row-input_xl _m_b_20_tb">' +
												'<label class="-ol-label _p_l_0 _text_center" for="k_id_name">' +
													'<span class="-ol-label-text">Name</span>' +
												'</label>' +
												'<div class="-ol-input-wrap">' +
													'<input class="-ol-input _text_center c-form__required" placeholder="Name" name="first_name" id="k_id_name" autocorrect="off" autocapitalize="off">' +
												'</div>' +
											'</div>' +
											'<div class="-ol-row-input -ol-row-input_xl _m_b_20_tb">' +
												'<label class="-ol-label _p_l_0 _text_center" for="k_id_email">' +
													'<span class="-ol-label-text">E-mail</span>' +
												'</label>' +
												'<div class="-ol-input-wrap">' +
													'<input class="-ol-input _text_center c-form__required" type="email" data-c-form-type="email" placeholder="E-mail" name="email" id="k_id_email" autocorrect="off" autocapitalize="off">' +
												'</div>' +
											'</div>' +
											'<input type="hidden" name="listID" class="c-video__id-input" value="' + formID + '">' +
											'<button type="submit" class="-ol-btn -ol-btn_w_fix_lg _w_full">' +
												'<span class="-ol-btn__text">Jetzt registrieren</span>' +
											'</button>' +
										'</form>' +
									'</div>' +
								'</div>' +
							'</div>' +
						'</div>'
					}

					htmlList += '<div class="b-list-blocks__item -ol-col-4 -ol-col-tb-6 -ol-col-mb-12 c-video">' +
						'<div class="b-video">' +
							'<div class="b-video__item">' +
								'<div' + btnPlayId + ' class="b-video__media' + nextPopup + '">' +
									'<div class="b-video__media-btn"></div>' +
									'<div class="b-video__media-video" style="background-image: url( ' + item.curtains.pending.backgroundImage + ' );"></div>' +
								'</div>' +
								'<h4 class="b-video__heading">' + item.title + '</h4>' +
								'<p class="b-video__subheading">' + date + '</p>' +
								'<div class="b-text">' + item.description + '</div>' +
							'</div>' +
							'<div class="b-video__item _flex">' +
								'<div' + linkPlayId + ' class="b-link-next _cur_p' + nextPopup + '">' +
									'<div class="b-link-next__text">Erfahren Sie mehr</div>' +
								'</div>' +
							'</div>' +
						'</div>' + nextPopupModal +
					'</div>';
				});

				if ( htmlList.length ) {

					result = '' +
						'<div class="b-heading-4 _m_b_45 _m_b_30_tb_xs">' +
							'<div class="b-heading-4__title b-heading-4__title_lg">' +
								'<h3 class="b-heading-4__title-text">' + title + '</h3>' +
							'</div>' +
						'</div>' +
						'<div class="b-list-blocks b-list-blocks_p b-list-blocks_30 _m_b_70 _m_b_60_tb _m_b_40_mb">' +
							'<div class="b-list-blocks__inner _f_wrap' + reverseClass + '">' + htmlList + '</div>' +
						'</div>';
				}

				$( '.' + className ).html( result );

				data.results.forEach( function( item, i, arr ) {

					window.initBambuserLiveShopping({
						showId: item.id,
						node: document.getElementById( className + '__btn-play-' + i ),
						type: 'overlay',
					});

					window.initBambuserLiveShopping({
						showId: item.id,
						node: document.getElementById( className + '__link-play-' + i ),
						type: 'overlay',
					});
				});

				$( '.c-video__form' ).each( function( index, element ) {

					var $this = $( this ),
						typeID = $this.find( '.c-video__id-input' ).val();

					// Connect liveshow registration form with custom Klaviyo list
					if ( typeID ) {
						$this.libriform({
							data: $this.serialize() + '&g=' + typeID, // important to add "g" in data
							url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe?a=UpXmWE&g=' + typeID, // AND in url too
						});
					}

					// Connect liveshow registration form with general Klaviyo list
					$this.libriform({
						data: $this.serialize() + '&g=TLDXwQ', // important to add "g" in data
						url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe?a=UpXmWE&g=TLDXwQ', // AND in url too
						callBackSuccess: function( $form, data ) {
							$form.trigger( 'reset' );
							$( '.c-form__btn-done' ).click();
							$( '.c-manipulate-class__form-success--4' ).click();
						},
						callBackError: function( $form, data ) {
							$form.trigger( 'reset' );
							$( '.c-form__btn-done' ).click();
							$( '.c-manipulate-class__form-error--5' ).click();
						}
					});
				});

			},
			error: function( data ) {
			}
		});
	}
});

$( window ).on( 'touchmove scroll', function( even ) {

	onTop();
	onBottom();
	onScroll( even );
});

